import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'RenderProductLines',
  props: {
    rowData: {}
  },
  setup(__props: any) {


const value = ref(false)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.rowData.pl_info?.length == 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(_ctx.rowData.pl_info[0].pl_short_name), 1)
        ], 64))
      : (_ctx.rowData.pl_info?.length > 1)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "text-primary underline cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = true))
          }, _toDisplayString(_ctx.rowData.pl_info.length), 1))
        : _createCommentVNode("", true),
    _createVNode(BaseModal, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.rowData.description) + " Product Lines", 1)
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowData.pl_info, (pl) => {
          return (_openBlock(), _createElementBlock("div", { key: pl }, _toDisplayString(pl.pl_short_name) + " / " + _toDisplayString(pl.pl_description), 1))
        }), 128))
      ]),
      actions: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          rounded: "",
          flat: "",
          label: label('close')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})